import { render, staticRenderFns } from "./GeneralProductInformationStepHost.vue?vue&type=template&id=d1de23f2&"
import script from "./GeneralProductInformationStepHost.vue?vue&type=script&lang=js&"
export * from "./GeneralProductInformationStepHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports